import React from 'react';

import PropTypes from 'prop-types';
import { Button, Popover, Popconfirm, Icon } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';
// `?react` so vite-plugin-svgr returns a React component (webpack svg-react-loader parity).
// Without it Vite returns the asset URL string → `<MyIcon/>` throws DOMException (invalid element name).
import MyIcon from './dots.svg?react';

import { DocClickManger } from '../../internals/ClickHandle';

const GlobalStyles = createGlobalStyle`
    .clad-dropdownoptions {
        animation: none;
        padding-top: 0;
        .ant-popover-arrow {
            display: none;
        }

        .ant-popover-inner-content {
            padding: 0;
        }
    }

    .clad-dropdownoptions-confirm {
        padding-top: 0;
        .ant-popover-arrow {
            display: none;
        }
    }
`;

const StyledList = styled.ul`
    list-style: none;
    min-width: 120px;
    padding: 0;
    margin: 0;

    li {
        cursor: pointer;
        padding: 10px;
        :hover {
            background: #f8f8f8;
        }

        &.disabled {
            cursor: not-allowed;
            color: #ccc;
        }
    }
`;

const StyledButton = styled(Button)`
    :hover {
        svg {
            path {
                fill: #000;
            }
        }
    }

    svg {
        position: relative;
        top: 2px;
        width: 14px;
        height: 15px;
        path {
            fill: #888;
        }
    }
`;

const OptionsList = ({ children }) => {
    return <StyledList data-cy="actions-list">{children}</StyledList>;
};

class DropDownOptions extends React.PureComponent {
    static propTypes = {
        options: PropTypes.arrayOf(PropTypes.object),
        size: PropTypes.oneOf(['small', 'default', 'large'])
    };

    static defaultProps = {
        size: 'small'
    };

    constructor(props) {
        super(props);
        this.defaultOption = null;
        this.state = {
            default: this.defaultOption,
            visible: false,
            confirm: false
        };
    }

    handleOptClick = opt => {
        if (opt.action) {
            opt.action();
            return;
        }

        this.confirmTitle = opt.confirm.title;

        this.onCancel = opt.confirm.onCancel;

        this.onConfirm = opt.confirm.onConfirm;

        setTimeout(() => {
            this.setState({
                confirm: true,
                visible: false
            });
        }, 100);
    };

    hideConfirmPopup = visible => {
        this.setState({
            confirm: false
        });
    };

    viewMoreOptions = () => {
        if (!this.hasScrollEvent) {
            this.hasScrollEvent = true;
            document.addEventListener('scroll', this.close, true);
        }

        this.setState({
            visible: !this.state.visible
        });
    };

    close = e => {
        this.setState({
            visible: false
        });

        if (this.state.confirm === true) {
            this.setState({
                confirm: false
            });
        }
    };

    componentWillUnmount() {
        if (this.hasScrollEvent) {
            document.removeEventListener('scroll', this.close, true);
        }
    }

    render() {
        const { props } = this;

        const options = [];

        this.props.options.forEach(option => {
            if (option.default === true) {
                this.defaultOption = (
                    <Button
                        ref={el => {
                            this.button = el;
                        }}
                        icon={option.icon ? option.icon : null}
                        size={props.size || 'small'}
                        onClick={option.action}
                    >
                        {option.name}
                    </Button>
                );
            } else {
                options.push(
                    <li
                        className={option.disabled ? 'disabled' : null}
                        key={option.name}
                        style={option.style}
                        onClick={
                            option.disabled
                                ? null
                                : () => this.handleOptClick(option)
                        }
                    >
                        {option.icon && (
                            <Icon
                                type={option.icon}
                                style={{ marginRight: 10 }}
                            />
                        )}
                        {option.name}
                    </li>
                );
            }
        });

        return (
            <div
                ref={el => {
                    this.el = el;
                }}
            >
                <GlobalStyles />
                {(this.state.visible || this.state.confirm) && (
                    <DocClickManger
                        el={this.el}
                        onDocClick={() => {
                            setTimeout(() => {
                                this.close();
                            }, 10);
                        }}
                    />
                )}
                <Button.Group>
                    {this.state.default}
                    <Popconfirm
                        placement="bottomRight"
                        overlayClassName="clad-dropdownoptions-confirm"
                        visible={this.state.confirm}
                        title={this.confirmTitle}
                        onCancel={this.onCancel}
                        onConfirm={this.onConfirm}
                        okText={_('Yes')}
                        cancelText={_('No')}
                    >
                        <Popover
                            trigger="click"
                            placement="bottomRight"
                            overlayClassName="clad-dropdownoptions"
                            visible={this.state.visible}
                            content={
                                this.state.visible ? (
                                    <OptionsList>{options}</OptionsList>
                                ) : null
                            }
                        >
                            <StyledButton
                                onClick={this.viewMoreOptions}
                                size={props.size || 'small'}
                            >
                                <MyIcon />
                            </StyledButton>
                        </Popover>
                    </Popconfirm>
                </Button.Group>
            </div>
        );
    }
}

export default DropDownOptions;
